import React, { useState, useEffect, useContext } from 'react';
import { Box, Button, Divider, Grid, Tab, Typography, Link, useTheme } from '@mui/material';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
// import { TabContext, TabList, TabPanel } from '@mui/lab';
// import VulnerabilityOverview from './VulnerabilityOverview';
// import Security from './Security';
// import Consequences from './Consequences';
import Vulnerabilities from './Vulnerabilities';
// import Likelihood from './Likelihood';
import Threats from './Threat';
import VulnerabilityReview from './VulnerabilityReview';
import CriticalAssets from '../SecurityAssessment/CriticalAssets';
import SecurityAssessmentTool from '../SecurityAssessment/SecurityAssessmentTool';
// import FERCSecuirtyChecklistv5 from '../SecurityAssessment/FERCSecuirtyChecklistv5';
import ThreatVulnLikelihoods from './ThreatVulnLikelihood';
import CorrectiveActions from '../SecurityAssessment/CorrectiveActions';
import WidgetWrapper from '../../components/WidgetWrapper';
import Header from '../../components/Header';
import FERCRiskEquationLong from './images/FERCRiskEquationLong.png';
import VulnAssessmentReport from './VulnAssessmentReport';
// import { AssessmentContext } from '../SecurityGroup1';


const VulnerabilityAssessment = ({securityGroup, damData, setProcessValue}) => {
    const [tabValue, setTabValue] = useState('1');
    const theme = useTheme();  
    const [activeStep, setActiveStep] = React.useState(0);
    const [completed, setCompleted] = React.useState({});
    // const [assessmentID2, userId] = useContext(AssessmentContext);

    // console.log("ASESSMENT AND USER IDS");

    // console.log(assessmentID2);
    // console.log(userId);

    const handleChange = (event, newValue) => {
    setTabValue(newValue);
    }
    
    const steps = ['Overview', 'Critical Assets', 'Vulnerabilities', 'Threats', 'Threat Profiles', 'Security Assessment', 'Asset Risk Score', 'Corrective Actions' ];
      
    const totalSteps = () => {
        return steps.length;
    };
    
    const completedSteps = () => {
        return Object.keys(completed).length;
    };
    
    const isLastStep = () => {
        return activeStep === totalSteps() - 1;
    };
    
    const allStepsCompleted = () => {
        return completedSteps() === totalSteps();
    };
    
    const handleNext = () => {
        const newActiveStep =
        isLastStep() && !allStepsCompleted()
            ? // It's the last step, but not all steps have been completed,
            // find the first step that has been completed
            steps.findIndex((step, i) => !(i in completed))
            : activeStep + 1;
        setActiveStep(newActiveStep);
    };
    
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    
    const handleStep = (step) => () => {
        setActiveStep(step);
    };
    
    const handleComplete = () => {
        const newCompleted = completed;
        newCompleted[activeStep] = true;
        setCompleted(newCompleted);
        handleNext();
    };
    
    const handleReset = () => {
        setActiveStep(0);
        setCompleted({});
    };

   return (
    <Box sx={{ width: '100%' }}>
        <Box sx={{ m:'2em' }}>
            <Typography variant="h1">Vulnerability Assessment: "ASSESSMENT NAME"</Typography>
            <Divider />
        </Box>
        
                <Stepper nonLinear activeStep={activeStep}>
                    {steps.map((label, index) => (
                    <Step key={label} completed={completed[index]}>
                        <StepButton color="inherit" onClick={handleStep(index)}>
                        {label}
                        </StepButton>
                    </Step>
                    ))}
                </Stepper>
               
                <div>
                    {allStepsCompleted() ? (
                    <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                            All steps completed - you&apos;re finished
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button onClick={handleReset}>Reset</Button>
                        </Box>
                    </React.Fragment>
                    ) : (
                    <React.Fragment>
                        {/* <Typography sx={{ mt: 0, mb: 0, py: 1 }}>
                        Step {activeStep + 1} */}
                        {/* </Typography> */}
                        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2, mb: 1 }}>
                        <Button
                            variant='contained'
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                        >
                            Back
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        <Button variant='contained' onClick={handleNext} sx={{ mr: 1 }}>
                            Next
                        </Button>
                        {activeStep !== steps.length &&
                            (completed[activeStep] ? (
                            <Typography variant="caption" sx={{ display: 'inline-block' }}>
                                Step {activeStep + 1} already completed
                            </Typography>
                            ) : (
                            <Button onClick={handleComplete}>
                                {completedSteps() === totalSteps() - 1
                                ? 'Finish'
                                : 'Complete Step'}
                            </Button>
                            ))}
                        </Box>
                    </React.Fragment>
                    )}
                    <Divider />
                </div>
                <Box sx={{ mt:'0.5em' }}>
                    {activeStep===0 && (
                        <Box>
                             <Grid container spacing={2}>
                                <Grid item size={12}>
                                     <WidgetWrapper> 
                                        <Typography>Complete steps 2 through 7 of the <i>Vulnerability Assesssment</i> tab.</Typography>
                                        <Typography sx={{ m: '1em' }}><li>Add "Critical Assets" to this assessment.</li></Typography>
                                        <Typography sx={{ m: '1em' }}><li>Complete FERC's "Security Assessment" for each critical asset.</li></Typography>
                                        <Typography sx={{ m: '1em' }}><li>Create "Threat Profiles" for each critical asset.</li></Typography>
                                        <Typography sx={{ m: '1em' }}><li>Review your "Asset Risk Scores" and add risk management decisions for each.</li></Typography>
                                        <Typography sx={{ m: '1em' }}><li>If necessary, add "Corrective Actions" to address results of the secruity assessment.</li></Typography>
                                        {/* <Typography sx={{ m: '1em' }}><li>Complete the "FERC Security Checklist v5". This step is optional, but it prepares personnel for the FERC auditors and is included in the assessment report if completed.</li></Typography> */}
                                    </WidgetWrapper>
                                </Grid>
                            </Grid>
                        </Box>

                    )}
                     {activeStep===1 && (
                        <CriticalAssets activeStep={activeStep} setActiveStep={setActiveStep} />
                    )}
                    {activeStep===2 && (
                        <Vulnerabilities activeStep={activeStep} setActiveStep={setActiveStep} />
                    )}
                    {activeStep===3 && (
                        <Threats activeStep={activeStep} setActiveStep={setActiveStep} />
                    )}
                    {activeStep===4 && (
                        <ThreatVulnLikelihoods activeStep={activeStep} setActiveStep={setActiveStep} />
                    )}
                    {activeStep===5 && (
                        <SecurityAssessmentTool activeStep={activeStep} setActiveStep={setActiveStep} />
                    )}
                    {activeStep===6 && (
                        <VulnerabilityReview activeStep={activeStep} setActiveStep={setActiveStep} />
                        // <FERCSecuirtyChecklistv5 handleNext={handleNext} activeStep={activeStep} setActiveStep={setActiveStep} />
                    )}
                    {activeStep===7 && (
                        <CorrectiveActions handleNext={handleNext} />
                        // <VulnAssessmentReport activeStep={activeStep} handleNext={handleNext} />
                    )}
                </Box>
            </Box>


    // <Box>
    //     <TabContext value={tabValue}>
    //         <Box sx={{ borderBottom: 5, borderColor: 'divider'}}>
    //             <TabList onChange={handleChange} >
    //                     <Tab sx={{ border: 2 }} label='1-Overview' value='1' />  {/* iconPosition accepts start, bottom, top, end as values*/}
    //                     <Tab sx={{ border: 2 }} label='2-Consequences' value='2' />
    //                     <Tab sx={{ border: 2 }} label='3-Vulnerabilities' value='3' />
    //                     <Tab sx={{ border: 2 }} label='4-Likelihood' value='4' />
    //                     <Tab sx={{ border: 2 }} label='5-Threat' value='5' />
    //                     <Tab sx={{ border: 2 }} label='6-Review Vulnerability Assessment' value='6' />
    //             </TabList>
    //         </Box>
    //         <TabPanel value='1'>
    //             <VulnerabilityOverview damData={damData} setProcessValue={setProcessValue} setTabValue={setTabValue} assessmentID={assessmentID} />
    //         </TabPanel>
    //         <Box sx={{ backgroundColor: theme.palette.background }}>
    //         <TabPanel value='2'>
    //             <Consequences setTabValue={setTabValue} assessmentID={assessmentID} />
    //         </TabPanel>
    //         <TabPanel value='3'>
    //             <Vulnerabilities />
    //         </TabPanel>
    //         <TabPanel value='4'>
    //             <Likelihood />
    //         </TabPanel>
    //         <TabPanel value='5'>
    //             <Threat />
    //         </TabPanel>
    //         <TabPanel value='6'>
    //             <VulnerabilityReview />
    //         </TabPanel>
    //         </Box>
    //     </TabContext>
    //     </Box>
         )
        }
        
        export default VulnerabilityAssessment